import axios from 'axios';
import * as actionTypes from './actionTypes';

export const sendMessageLoading = () => {
    return {
        type: actionTypes.SEND_MESSAGE_LOADING
    }
};

export const sendMessageFail = (error) => {
    return {
        type: actionTypes.SEND_MESSAGE_FAIL,
        error: error
    }
};

export const sendMessageSuccess = (data) => {
    return {
        type: actionTypes.SEND_MESSAGE_SUCCESS,
        payload: data
    }
};

export const sendMessageInitialize = () => {
    return {
        type: actionTypes.SEND_MESSAGE_INITIALIZE
    }
};

export const initializeSendMessage = () => {
    return dispatch => {
        dispatch(sendMessageInitialize())
    }
};

export const sendMessage = (token, data) => {
    return dispatch => {
        dispatch(sendMessageLoading());
        axios.post('/api/sendmessage', {...data, token: token})
            .then(res => {
                console.log(res);
                dispatch(sendMessageSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(sendMessageFail(message));
        });
    }
};

export const sendMessageReseller = (token, data) => {
    return dispatch => {
        dispatch(sendMessageLoading());
        axios.post('/reseller/sendmessage', {...data, token: token})
            .then(res => {
                console.log(res);
                dispatch(sendMessageSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(sendMessageFail(message));
        });
    }
};

export const sendMessageSuperReseller = (token, data) => {
    return dispatch => {
        dispatch(sendMessageLoading());
        axios.post('/superreseller/sendmessage', {...data, token: token})
            .then(res => {
                console.log(res);
                dispatch(sendMessageSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(sendMessageFail(message));
        });
    }
};

export const sendMessageAdmin = (token, data) => {
    return dispatch => {
        dispatch(sendMessageLoading());
        axios.post('/admin/sendmessage', {...data, token: token})
            .then(res => {
                console.log(res);
                dispatch(sendMessageSuccess(res.data));
            }).catch(error => {
                //console.log('error data', error);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                console.log('logging message', message);
                dispatch(sendMessageFail(message));
        });
    }
};

// export const searchMacReseller = (token, mac) => {
//     return dispatch => {
//         dispatch(searchMacLoading());
//         axios.get('/reseller/searchmac/' + mac + '?token=' + token )
//             .then(res => {
//                 console.log(res);
//                 dispatch(searchMacSuccess(res.data));
//             }).catch(error => {
//                 //console.log('error data', error);
//                 let message = "Server error, try again later";
//                 if (error.response){
//                     message = error.response.data.message;
//                 }
//                 console.log('logging message', message);
//                 dispatch(searchMacFail(message));
//         });
//     }
// };

// export const searchMacSuperReseller = (token, mac) => {
//     return dispatch => {
//         dispatch(searchMacLoading());
//         axios.get('/superreseller/searchmac/' + mac + '?token=' + token )
//             .then(res => {
//                 console.log(res);
//                 dispatch(searchMacSuccess(res.data));
//             }).catch(error => {
//                 //console.log('error data', error);
//                 let message = "Server error, try again later";
//                 if (error.response){
//                     message = error.response.data.message;
//                 }
//                 console.log('logging message', message);
//                 dispatch(searchMacFail(message));
//         });
//     }
// };

